export default __webpack_public_path__ + "static/media/unplugged.49a4d05a.svg";